/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { alpha, Theme } from "@mui/material";

export const hoverStyles = (theme: Theme) => ({
	filter: "brightness(80%)",
	transitionDuration: "0.5s",
	"&:hover": {
		backgroundColor: alpha(theme.palette.background.default, 0.3),
		filter: "brightness(100%)",
		cursor: "pointer",
	},
});

export const hoverActiveStyles = () => ({
	filter: "brightness(100%)",
});
